export class InventoryIncidentDto {
  public stockKeepingUnitId: number = 0
  public userId: number = 0
  public pickingRouteId: number | undefined = 0
  public positionId: number | undefined = undefined
  public typeInventoryIncidentId: number = 0
  public incidentDate: Date = new Date()
  public incidentQuantity: number = 0
  public flowId: number = 0
}

export class InventoryIncidentInfoDto extends InventoryIncidentDto {
  public inventoryIncidentId: number = 0
}

export class InventoryIncidentFilterDto extends InventoryIncidentDto {
  public inventoryIncidentId: number = 0
}

export class InventoryIncidentCreateDto extends InventoryIncidentDto {}

export class InventoryIncidentUpdateDto extends InventoryIncidentDto {
  public inventoryIncidentId: number = 0
}

export enum EnumTypeInventoryIncident {
  Excess = 1
}

export enum EnumFlow {
  ASN_VALIDATION = 1,
  PICKING_ROUTE_VALIDATION = 2,
  DISPATCH_VALIDATION = 3,
  DISPATCH_VALIDATION_DECLARE_ERROR = 4,
  PICKING_ROUTE_SKIP_POSITION = 5,
  PICKING_ROUTE_WITHOUT_UNITS = 6
}

export class InventoryIncidentInput {
  public quantity: number = 0
}
